type IconProps = { className?: string };

export function FreeBrandIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden>
      <rect width="24" height="24" rx="6" fill="#CD0037" />
      <path
        fill="#fff"
        d="M6.5 16V8h2.1l2.2 5.8L13 8h2.1v8h-2v-5.3L10.8 16h-1.3L8.5 10.7V16H6.5zm7.2 0V8h3.6c1.4 0 2.3.9 2.3 2.2 0 1-.5 1.7-1.4 2l1.6 3.8h-2.3l-1.4-3.4h-1v3.4h-2.4zm2.4-5.2c.6 0 1-.3 1-.8s-.4-.8-1-.8h-1.2v1.6H16.1z"
      />
    </svg>
  );
}
